// Fit badge updater — scans visible slides for wearing alt text
window.evdnceUpdateFitBadge = function() {
  var badge = document.querySelector('[id^="FitNoteBadge-"]');
  if (!badge) return;
  var fallback = badge.dataset.fallback || '';

  // Scan all visible (non-hidden) slides for a matching alt text
  var visibleSlides = document.querySelectorAll(
    '.swiper--product-gallery .swiper-slide:not(.evdnce-gender-hidden)'
  );

  var matchedText = null;
  var firstAlt = null;

  visibleSlides.forEach(function(slide) {
    if (matchedText) return; // already found
    var img = slide.querySelector('img');
    if (!img) return;
    var rawAlt = img.getAttribute('alt') || '';
    var alt = rawAlt.replace(/^\[.*?\]\s*/, '');
    if (!firstAlt && alt) firstAlt = alt;
    var match = alt && alt.match(/.+is .*(wearing.+)/i);
    if (match) matchedText = match[0];
  });

  if (matchedText) {
    badge.textContent = matchedText;
    badge.style.display = '';
  } else if (fallback) {
    badge.textContent = fallback;
    badge.style.display = '';
  } else {
    badge.style.display = 'none';
  }
};

// Run after reorderSwiper has had time to complete
(function() {
  function init() {
    if (typeof window.evdnceUpdateFitBadge === 'function') {
      window.evdnceUpdateFitBadge();
    }
  }
  setTimeout(init, 600);
  setTimeout(init, 1500);
})();
